module.exports = __webpack_public_path__ + "img/Flag_RD.d47704db.png";